module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--07.ef93a86e.png";